











import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from '../../../../../default/js/shared/helpers/enhanced-ecommerce';

@Component({
  name: 'catalog-product-add-to-cart',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) private product!: object;
  @Prop({required: false, default: 1}) private qty: number;

  private loadingAddToQuote: boolean = false;
  private addToCartSuccess: boolean = false;
  private isCheckoutChild: boolean = false;

  private get isSaleable(): boolean {
    return !(this.product['frontend_stock'] <= 0 && this.product['not_saleable']);
  }

  private async addToQuoteAction(): Promise<void> {
    this.loadingAddToQuote = true;

    try {
      let productPayload = {
        sku: this.product['sku'],
        qty: this.qty,
      };

      await this.$store.dispatch('CheckoutCart/addProductToQuote', productPayload);
      if( this.isCheckoutChild ) {
        await this.$store.dispatch('CheckoutCart/fetchCartTotals', 'cart');
      }
      await this.$store.dispatch('CheckoutCart/showProductAdded', true);

      await this.$store.dispatch(
        'MeasurementProtocol/fireGaEvent', {
          event: 'add_to_cart',
          data: {
            product: this.product,
            qty: this.qty,
          }
        }
      );
      enhancedEcommerce.addProductAddToCart(this.product, this.qty);

      await this.$store.dispatch('GlobalMessages/addGlobalMessage', {
        id: `add-${this.product['sku']}`,
        message: this.$t('{productName} has been added to your shopping cart', {productName: this.product['name']}),
        type: '--success'
      });
    } catch (e) {
      await this.$store.dispatch('GlobalMessages/addGlobalMessage', {
        id: `error-${this.product['sku']}`,
        message: this.$t('Failed to add to cart'),
        type: '--error'
      });
    } finally {
      this.loadingAddToQuote = false;
    }
  }

  private mounted(): void {
    this.isCheckoutChild = !!this.$root.$el.querySelector('#checkout-cart');
  }
}
